// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__Z2MaG","buttons":"RemoveExpirationActionButtons_buttons__2TfKo"};